<template>
  <div>
    <div class="pl-3 pr-3 pl-md-4 m-0">
      <shop-ticket-description-panel v-bind:getSelectedItem="getSelectedItem"/>
    </div>
    <b-row class="w-100 m-0 mt-5 ">
      <b-col order-lg="0" order-md="0" lg="4" class="">

        <!-- DATE INPUT -->
        <b-input type="text" size="md" variant="light" placeholder="Tag wählen" id="selectdate"
                class="mt-0 mb-2 text-center InputBorder fakeRollover"
                v-model="datePicker.selectedDate"
                @click="showDateModal"/>

          <!-- CALENDAR MODAL -->
          <b-modal ref="DateModal" centered  hide-footer hide-header title="">
            <form @submit.stop.prevent="handleSubmit">
              <datepicker :inline="true" :language="datePicker.de"
                :monday-first="true"
                :minimumView="'day'"
                :maximumView="'day'"
                :initialView="'day'"
                :full-month-name="true"
                :placeholder="'Tag auswählen'"
                :disabledDates="datePicker.disabledDates"
                :highlighted="datePicker.highlighted"
                :day-cell-content="datePicker.daycellcontent"
                @selected="datePicker.dateSelected"
                @changedMonth="datePicker.changedMonth"
                :format="datePicker.customFormatter"
                calendar-class="w-100 "
                input-class="bg-white mt-0 p-0 pl-2 text-center"
                :bootstrap-styling="true" >
              </datepicker>
              <ul class="mt-2 mb-0">
                <li class="text-success" style="list-style-type: square;"><span class="text-dark">ausreichend Plätze verfügbar</span></li>
                <li class="text-warning" style="list-style-type: square;"><span class="text-dark">wenig Plätze verfügbar</span></li>
                <li class="text-muted" style="list-style-type: square;"><span class="text-dark">leider nicht verfügbar</span></li>
              </ul>
            </form>
          </b-modal>

          <div v-if="ticketTimes.length > 0" class="timeSlotContainer">
          <b-dropdown
            variant="light" no-flip
            :text="setSelectTimeSlotTitle"
            class="m-0 w-100 mb-2 text-dark timeSelectorBtn">
              <b-dropdown-item-button  v-for="(timeSlot, index) in ticketTimes" class="text-center" variant="light" :key="index"  @click="changeTimeslot(timeSlot, index)">
                {{ timeSlot.start.slice(11,16)  }}
              </b-dropdown-item-button>
          </b-dropdown>
        </div>

        <shop-ticket-person-group-prices v-bind:getSelectedItemId="getSelectedItemId" v-if="ticketTimes != undefined && ticketTimes.length > 0 && !this.$store.getters.getChachedCustomerShiftTicket"/>
        <div style="text-align: center; border-top: 1px solid #ced4da;" v-if="this.currentPrice != undefined"> Total: <strong>{{this.currentPrice}} EUR</strong></div>
        <!-- SHOW STATIC PERSONS LIST FOR UPDATES -->
        <div v-if="this.$store.getters.getChachedCustomerShiftTicket" class="mt-4">
          <div class="text-center text-uppercase">Original Buchung:</div>
          <p class="mt-1 text-center text-uppercase font-weight-600">
            {{this.$store.getters.getChachedCustomerShiftTicket.description}}
          </p>
        </div>
      </b-col>

      <!-- MAP -->
      <b-col order-lg="1" order-md="1" lg="8" class="m-0 p-0 pl-4 pl-sm-3 pl-md-3 pl-lg-0 pr-4 pr-sm-3 pr-md-3 pr-lg-2 mt-2 mt-md-1 mt-lg-0 ">
        <div v-if="ticketLayouts.length > 0" class="">

            <b-tabs pills card v-model="tabIndex" class="mt-2" v-if="ticketLayouts.length > 1" >
              <b-tab class="btn btn-light" v-for="(layout,index) in ticketLayouts" @click="changeLayout(layout,index)" :title="layout.title" :key="index">
                {{layout.description}}
              </b-tab>
            </b-tabs>

            <l-map ref="map" :options="mapOptions" :center="center" :crs="crs" class="leaflet"
              :maxBounds="[[0, 0], [currentLayout.height, currentLayout.width]]" :maxBoundsViscosity="0.75" @update:zoom="updateZoom">
                  <l-image-overlay
                    :url="'/' + currentLayout.image"
                    :bounds="[[0, 0], [currentLayout.height, currentLayout.width]]"/>

                  <l-marker v-for="(table, index) in currentTables" :key="index" :lat-lng="{lat: table.y, lng: table.x}" @click="changeSelectedTable(table)">
                    <l-icon :iconAnchor="getTableAnchor(table.typeId)" :iconSize="getTableSize(table.typeId)">
                      <div :style="getTableStyle(table)" v-html="getTableIconByTypeId(table.typeId)"  :id="table.typeId" ></div>
                    </l-icon>
                  </l-marker>
            </l-map>
        </div>
        <div v-if="ticketLayouts.length == 0" class="mt-1" style="height:300px;">
          <p>Bitte einen Tag wählen</p>
        </div>
      </b-col>


    <b-col order-lg="4" order-md="4" sm="12" lg="12" class="p-0 m-0 pl-4 pl-sm-2 pl-md-0">
      <div class="d-inline-block mt-3 p-0 mr-0 ml-1 float-right" v-if="ticketLayouts.length > 0">
        <ul class="mt-1 ml-1 mr-1 pr-0 list-inline mb-1">
                <li class="d-inline-block mr-2" :style="getTableFillStyleForState(getTableColors()[0], 'availableColor')"><i class="fa fa-square mr-2" aria-hidden="true"></i><span class="text-dark">verfügbar</span></li>
                <li class="d-inline-block mr-2" :style="getTableFillStyleForState(getTableColors()[0], 'selectionColor')"><i class="fa fa-square mr-2" aria-hidden="true"></i><span class="text-dark">ausgewählt</span></li>
                <li class="d-inline-block " :style="getTableFillStyleForState(getTableColors()[0], 'occupiedColor')"><i class="fa fa-square mr-2" aria-hidden="true"></i><span class="text-dark">nicht verfügbar</span></li>
        </ul>
        </div>
    </b-col>
</b-row>

</div>
</template>

<script>

import moment from 'moment';

import {LMap, LImageOverlay, LMarker, LIcon } from 'vue2-leaflet';

import Datepicker from 'vuejs-datepicker';
import {en, de} from 'vuejs-datepicker/dist/locale';

import ShopTicketPersonGroupPrices from  "@/components/ShopTicketPersonGroupPrices";
import ShopTicketDescriptionPanel from "@/components/ShopTicketDescriptionPanel";


export default {
  name: "ShopTicketService",
  components: {
    LMap, LImageOverlay, LIcon, LMarker, Datepicker,
    ShopTicketPersonGroupPrices, ShopTicketDescriptionPanel
  },
  props: ["getSelectedItemId"],
  data(){
    return{
      iconSize: [32, 32],
      iconAnchor: [16, 16],
      zoomLevel: 1,
      currentScale: 1, // used for IconSizes (dynamic)
      tabIndex: 0,
      currentFrom: undefined,
      currentTo: undefined,
      currentLayout: undefined,
      currentTimeSlot: undefined,
      currentEventStart: undefined,
      currentTables: [],
      currentTableTypes: [],
      currentPrice: undefined,
      events: [], // holds data for the calendar
      ticketTimes: [], //holds one ticketDates ticketTimes (reload on click)
      ticketLayouts: [], // holds all rooms/Layouts

      /* Leaflet */
      crs: self.L.CRS.Simple,
      center: [0, 0],
      mapOptions: {
         zoomControl: false,
         attributionControl: false,
         zoomSnap: false,
         minZoom: -1.15,
         maxZoom: 1,
      },
      bounds: [[0, 0], [1000, 1000]],
      /* Datepicker */
      datePicker: {
        en: en,
        de: de,
        customFormatter(date) {
          return moment(date).format('DD MMMM YYYY');
        },
        selectedDate: undefined, // like yyyy-MM-dd
        disabledDates: {
          customPredictor: (date) => {
            // is that date in events ?
            //console.log(moment(date).format('YYYY-MM-DD'));
            if(this.events == undefined || this.events.length==0){
              return true;
            }

            let s = this.events.find( e =>{
             // console.log('hit:', e.start.slice(0, 10), moment(date).format('YYYY-MM-DD'), e.start.slice(0, 10) == moment(date).format('YYYY-MM-DD'));

              return e.start.slice(0, 10) == moment(date).format('YYYY-MM-DD'); //date.toISOString().slice(0, 10);
            });

            if(s != undefined && new Date( s.start) > new Date()){
             // console.log('enabled:');

              return false; // not disabled= enabled=clickable
            }
            //console.log('disabled: ', moment(date).format('YYYY-MM-DD'));
            return true;
          }
        },
        highlighted: {
/*          customPredictor: (  ) => { // (date)
            return false; // !

            // is that date in events[] ?
            let s = this.events.find( e => {
                return e.start.slice(0, 10) == date.toISOString().slice(0, 10);
            });

            if(s != undefined){ // if we find one ...highlight it
              return true;
            }
            return false;

          },   */
          includeDisabled: true // Highlight disabled dates
        },
        daycellcontent: (date)=>{ // this will render each cell in datepicker
          if(this.events == undefined || this.events.length==0){
              return date.date;
            }

          let day = this.events.find( e => {
            return e.start.slice(0, 10) == moment(date.timestamp).format('YYYY-MM-DD');
          });

          // color for the DAY number
          if(day != undefined){
            //console.log(day);

            return '<span style="color: '+ day.color +';">' + date.date + '<span>';
          }

          return '<span style="color: #eee;">' + date.date + '<span>';
        },
        dateSelected: (date) => {
         // console.log('Date Selected:', moment( date).format('YYYY-MM-DD'));

          this.selectDate(  moment( date).format('YYYY-MM-DD'));
          // Hide Modal after selection
          this.hideDateModal();
        },
        changedMonth: (month)=>{
            //console.log('change month', month);
                // set Default Dates
          this.currentFrom = moment(month).startOf('month').toISOString().slice(0, 10); // format as YYYY-MM-DD
          this.currentTo = moment(month).startOf('month').add(1, 'months').toISOString().slice(0, 10); // new Date(new Date().setDate(new Date().getDate() + 31 )).toISOString().slice(0, 10);

          //console.log( this.currentFrom, this.currentTo);

          // Load ticketDates from Server
          this.loadTicketDatesFromServer(this.getSelectedItem.id);

        }
      }
    };
  },
  methods: {
    updateZoom (level) {

      let base = 2;
      if (level < 0) {
        base = 0.5;
        level = level * -1;
      }

      this.currentScale = Math.pow(base, level);

      return;
/*
      if(this.$refs.map.mapObject._targets != undefined ){
        //console.log('->', this.$refs.map.mapObject._targets);


        let obj = this.$refs.map.mapObject._targets;
        let _types = this.currentTableTypes;

        Object.keys(obj).forEach(function(key) {

          //console.log('>',key, obj[key].options.icon);

          if (obj[key].options.icon != undefined) { // filter out any none Icon

            // get id of tableType from id in div html
            let _start = obj[key].options.icon.options.html.indexOf('id="',0);
            let _end = obj[key].options.icon.options.html.indexOf('"',_start+4);

            let _id = obj[key].options.icon.options.html.slice(_start+4,_end);

            // get size from type
            console.log('TypeId:', _types[_id].height, _types[_id].width );

            console.log('Icon:', obj[key].options.icon.options.iconSize);

            let scale = 1;
            let base  = 2;

            if (level < 0) {
              base = 0.5;
              level = level * -1;
            }

            scale = Math.pow(base, level);

            console.log('Scale: ', scale);
            obj[key].options.icon.options.iconSize =  [_types[_id].height * scale, _types[_id].width * scale];

            console.log('Icon2:', obj[key].options.icon.options.iconSize);
          }else{
            console.log('mäh');
          }

        });


      }else{
        console.log('!');

      }
      */
     /*  let iSize = 32;
      let scale = 1;
      let base  = 2;

      if (level < 0) {
        base = 0.5;
        level = level * -1;
      }
      scale = Math.pow(base, level);
      //console.log('scale:', scale, 'base:', base, 'zoom:', level);

      this.iconSize   = [iSize * scale, iSize * scale];
      this.iconAnchor = [(iSize * scale) / 2, (iSize * scale) / 2];
       */

    },
    selectDate(date){
     // console.log('D: ',  date);

      // find exact startTime of Event (Datepicker only holds the Day, but time is when the Click happend, not from event ?!)
          let s = this.events.find( e => {
           // console.log('->', e.start.slice(0, 10));

            return e.start.slice(0, 10) == date;
          });

          if(s != undefined){ // if we find one ..load and highlight it
            // console.log('Start: ', s );

            this.loadTicketTimesFromServer(this.getSelectedItem.id, s.start);
            // Delay the second call, so the first is most likley done :)
            setTimeout(() => {
              this.loadTicketLayoutsFromServer(this.getSelectedItem.id, s.start)
            }, 200);

          }
          // update input label also

          this.datePicker.selectedDate = moment(date).format('YYYY-MM-DD');//.format('D. MMMM YYYY'); // date.toLocaleDateString("de-DE", {  year: 'numeric', month: 'long', day: 'numeric'});// date.toISOString().slice(0, 10);
          //console.log('selectDate:', this.datePicker.selectedDate);
    },
    showDateModal()
    {
        //console.log('show date picker');
        this.$refs.DateModal.show();
    },
    hideDateModal() {
        this.$refs.DateModal.hide();
    },
    getTotalSum: function() {
      return (this.getSelectedItem.count * this.getSelectedItem.fixedPrice.toFixed(2));
    },
    getCachedItem() {
      return this.$store.getters.getCachedItemById(this.getSelectedItemId);
    },
    getTableIconByTypeId(tableId){
      return this.currentTableTypes[tableId].svgCode;
    },
    getTableStyle(table){

     // console.log('Table: ', table);

      let style = '';
      switch (table.state) {
        case 'Available':
          style= `fill: ${this.currentTableTypes[table.typeId].availableColor};` + 'transform: rotate('+table.angle+'deg);';
          break;
        case 'Occupied':
          style= `fill: ${this.currentTableTypes[table.typeId].occupiedColor}; cursor: auto;` + 'transform: rotate('+table.angle+'deg);';
          break;
        case 'Selected':
             // console.log(table.state);

          style= `fill:  ${this.currentTableTypes[table.typeId].selectionColor};` + 'transform: rotate('+table.angle+'deg);';
          break;
        default:
          style= `fill: ${this.currentTableTypes[table.typeId].defaultColor};` + 'transform: rotate('+table.angle+'deg);';
          break;
      }

     // console.log(table.state);

      return style;
    },
    async loadTicketDatesFromServer(productId, from='', to='') {
      // what 'FROM' date are we using?
      if(from == ''){
        //console.log('no FROM overwrite');
        from = this.currentFrom;
      }

      // what 'TO' date are we using?
      if(to == '' && this.currentTo != undefined){
        //console.log('no TO overwrite');
        to = this.currentTo;
      }

      if(this.getSelectedDateFromRoute())
      {
          to=null;
      }

      let config =this.$store.getters.getRestHeaderConfig;
      // prepare Header and Parameters
      config.params= {
          productId: productId,
          from: from,
          to: to,
          localeId: this.getSelectedLanguage.ident /* Language: de, en */
        };

        //console.log('Get TicketDates:', config);


      await this.$http
        .get(this.$store.getters.getRestServerBaseUrl + "/ticketDates", config)
        .then(response => {
        // console.log("GET ticketDates for: " + productId, response.data);

          if(response.data.length > 0){
            // add dates to cached product object
            this.getSelectedItem.ticketDates = response.data;

            this.updateTicketDates(this.getSelectedItem.ticketDates); // adds title of Ticket to it and color etc.c

            this.events = this.getSelectedItem.ticketDates; // this is the data the calendar uses

            if(this.datePicker.selectedDate == undefined)
            {
              //look for a date in the url
              if(this.getSelectedDateFromRoute())
              {
                this.selectDate(this.getSelectedDateFromRoute().format('YYYY-MM-DD'));
              }
              else
              {
                  if(this.events.length>0)
                  {
                      this.selectDate(this.events[0].start.slice(0,10));
                  }
              }

              // check if we  areupdating a Ticket
              if(this.getSelectedDateFromShiftTicket())
              {
                // reselect Date
                this.selectDate(this.getSelectedDateFromShiftTicket().slice(0,10));
              }
            }

           // console.log("ticketDates found: ", this.getSelectedItem.ticketDates.length , this.getSelectedItem);
          }else{
            this.getSelectedItem.ticketDates = []; // make sure there is an array...
            this.events = [];
            //console.log('Found NO ticket Dates!');
          }



        })
        .catch(err => {
          console.log("GET ticketDates Error: ",err);
        });
    },
    updateTicketDates: function(eventsZ) { // COLORS IN CALENDAR

      eventsZ.forEach(e =>{
       // console.log('e: ', e.start, new Date(e.start) < new Date());

        if(new Date(e.start) < new Date()) { // hide Events in the past
          e.color = "#AAAAAA";
          e.textColor = '#CCCCCC';
          e.borderColor ='#909090';
          e.expired = true;
        }else{

          // color by %
          let per = (e.freeTables / e.totalTables)*100;
          //console.log('% ', per);

          if(per < 10){
            e.color = "#c00000";
            e.borderColor ='#700000';
          }else if(per < 20){
            e.color = "#E99002";
            e.borderColor ='#E99002';
          }else{
            e.color = "#00c000";
            e.borderColor ='#007000';
          }
          e.textColor = '#FFFFFF';
          e.expired = false;
        }

        e.title = this.getSelectedItem.title;
        e.productId = this.getSelectedItem.id;

        e.editable = false;
        e.startEditable = false;
        e.durationEditable = false;
        e.resourceEditable = false;


      });

    },
    async loadTicketTimesFromServer(productId, eventStart) {

     //console.log('eventStart: ',eventStart);

      let config =this.$store.getters.getRestHeaderConfig;
      // prepare Header and Parameters
      config.params= {
          productId: productId,
          eventStart: eventStart, // make useable date ?
          localeId: this.getSelectedLanguage.ident /* Language: de, en */
        };

//console.log('TicketTimes: ', config.params);

      await this.$http
        .get(this.$store.getters.getRestServerBaseUrl + "/ticketTimes", config)
        .then(response => {
         // console.log("GET ticketTimes for: " + eventStart , productId, response.status);

          if(response.data.length > 0){
           // console.log("ticketTimes found: ", response.data);

            this.ticketTimes = response.data;

            this.ticketTimes.forEach(t =>{
                 t.cssClass = "timeSlot text-center";
            });

            // are we updating ?
            if(this.$store.getters.getChachedCustomerShiftTicket){
              //this.changeTimeslot({start: this.$store.getters.getChachedCustomerShiftTicket.reservationDateTime.slice(11,16)});

            }else{
              // select first
              this.ticketTimes[0].cssClass="timeSlot text-white bg-dark text-center";
              this.currentTimeSlot = this.ticketTimes[0];
            }


            this.currentEventStart = eventStart;
            this.currentTables = undefined;
            this.currentTableTypes = undefined;

          }else{
            //console.log('Found NO ticket Times!');
          }
        })
        .catch(err => {
          console.log("GET ticketTimes: ",err);
        });
    },
    async loadTicketLayoutsFromServer(productId, eventStart) {

      let config =this.$store.getters.getRestHeaderConfig;
      // prepare Parameters
      config.params= {
          productId: productId,
          eventStart: eventStart, // make useable date
          localeId: this.getSelectedLanguage.ident /* Language: de, en */
        };

      await this.$http
        .get(this.$store.getters.getRestServerBaseUrl + "/ticketLayouts", config)
        .then(response => {
          //console.log("GET ticketLayouts for: " + new Date(eventStart).toISOString() + " | " + productId, response.status);

          if(response.data.length > 0){
           // console.log("ticketLayouts found: ", response.data);
            this.ticketLayouts = response.data;
            response.data.selectedTable = undefined; // holds the seleced table in this layout
            //this.getSelectedItem.amountOfPersons = 1; // set min of 1 Person

            this.getSelectedItem.selectedLayout = response.data[0]; // default to first layout
            this.currentLayout = this.getSelectedItem.selectedLayout;

            this.setMapView();

            // just in case
            //console.log('Amount was:',this.getSelectedItem.amountOfPersons);

            if(this.getSelectedItem.amountOfPersons < this.getSelectedItem.minimumPersons){
              this.getSelectedItem.amountOfPersons = this.getSelectedItem.minimumPersons;
            }

            if(this.ticketTimes.length != 0){
              //console.log('change Timeslot after load Layouts');

              // reselect Time of Original Booking if we are an update(SHIFT Ticket)
              if(this.$store.getters.getChachedCustomerShiftTicket){
               // console.log('Shift Starttime',this.$store.getters.getChachedCustomerShiftTicket.reservationDateTime);

                if(!this.currentTimeSlot){
                 // console.log('TS was empty...');

                  this.changeTimeslot({start: this.$store.getters.getChachedCustomerShiftTicket.reservationDateTime}, 0);
                }else{
                  //console.log('TS was:', this.currentTimeSlot.start.slice(11,16), this.ticketTimes);
                  //check if there is the same timeslot available in this day's list, if no select first
                  let ts = this.ticketTimes.findIndex(i=> i.start.slice(11,16) === this.currentTimeSlot.start.slice(11,16));

                  if (ts) {
                    this.changeTimeslot(this.ticketTimes[ts], 0);
                  } else {
                    this.changeTimeslot(this.ticketTimes[0], 0);
                  }
                }

                // reselect Persons/Amount etc

               //console.log('TS ok');

                if(this.getSelectedItem.personGroups){
                 // console.log('PersonGroups detected: ', this.getSelectedItem.personGroups);

                  this.$store.getters.getChachedCustomerShiftTicket.persons.forEach(p => {
                      // run thru all Groups and find id
                      let pGroup = this.getSelectedItem.personGroups.find(x => x.id === p.id);
                      // update value
                      pGroup.numberOfPersons = p.numberOfPersons;

                       // find index in prices and update ion groups for correct price calc.
                      pGroup.index = pGroup.prices.findIndex(x=> x.numberOfPersons ===  p.numberOfPersons);

                      //console.log('after:', pGroup);

                  });

                  this.amountOFPersonsUpdated();
                }



              }else{
                this.changeTimeslot(this.ticketTimes[0], 0); // load first timeslot for tables
              }

            }


          }else{
            //console.log('Found NO ticket Layouts!');
          }
        })
        .catch(err => {
          console.log("GET ticketLayouts ERROR: ",err);
        });
    },


    async loadTicketTablesFromServer(productId, eventStart, layoutId, reservationStart, numberOfPersons) {

      let config =this.$store.getters.getRestHeaderConfig;
      // prepare Parameters
      config.params = undefined;
      let params = {
          productId: productId,
          eventStart: eventStart, // make useable date
          layoutId: layoutId,
          reservationStart: reservationStart,
          personGroups: [],
          localeId: this.getSelectedLanguage.ident /* Language: de, en */
      };

      this.getSelectedItem.personGroups.forEach(element => {

        params.personGroups.push({
          id: element.id,
          numberOfPersons: element.prices[element.index].numberOfPersons
        });
      });

     // console.log('Load Ticket Tables Params: ', config.params);


      await this.$http
        .post(this.$store.getters.getRestServerBaseUrl + "/ticketTables", params, config)
        .then(response => {

          if(response.data.tables.length > 0){
            //console.log("ticket Tables found: ", response.data.tables);

            this.currentTables = response.data.tables;
            this.currentTableTypes = response.data.types;
            //console.log('Table Types:', response.data.types);

        // if there was a table selected, reload also
         /*    if(this.currentLayout.selectedTable != undefined){
              this.changeSelectedTable(this.currentLayout.selectedTable);
            } */

            // check if there was a table selected, returned from the Server
            if(this.currentTables != undefined && this.currentTables.length > 0){
              this.currentTables.findIndex(e => {
                if(e.state=="Selected"){
                  //console.log('selected Table found:', e);
                  this.emitSetTableSelection(true);
                }
              });
            }
            // save date/time and amount for the "DirectBookingView"
            //console.log('Bookinginfo:', reservationStart , numberOfPersons );

            this.$store.dispatch('updateCachedBooking', { date: reservationStart, amount: numberOfPersons });


          }else{
            //console.log('Found NO ticket Tables!');
          }
        })
        .catch(err => {
          console.log("GET ticketTables: ",err);

        });
    },
    async loadTicketSelectTableFromServer(productId, eventStart, layoutId, reservationStart, numberOfPersons, tableId) {

      let config = this.$store.getters.getRestHeaderConfig;
      config.params = undefined; // make sure they are empty
      // prepare Parameters
      let params = {
          productId: productId,
          eventStart: eventStart, // make useable date
          layoutId: layoutId,
          reservationStart: reservationStart,
          personGroups: [],
          tableId: tableId
      };

      this.getSelectedItem.personGroups.forEach(element => {

        params.personGroups.push({
          id: element.id,
          numberOfPersons: element.prices[element.index].numberOfPersons
        });
      });

      //console.log('Params:', params, config);

      await this.$http
        .post(this.$store.getters.getRestServerBaseUrl + "/ticketSelectTable", params , config)
        .then(response => {
         // console.log("GET ticketSelectTable for: " + eventStart + " #:" + numberOfPersons+ " | " + productId, response.status);
         // console.log(response.data);

          this.currentTables = response.data.tables;
          this.currentTableTypes = response.data.types;
          this.currentPrice = response.data.price;


        })
        .catch(err => {
          console.log("GET ticketSelectTable: ", err);
        });
    },
    changeLayout(layout /* , index */){
      layout.selectedTable = undefined; //reset table selection
      this.getSelectedItem.selectedLayout = layout;
      this.currentLayout = layout;
      // console.log('selected Layout: ', index, layout);

      // reset view ?
      this.setMapView();

      // reselect TicketTime?


      this.loadTicketTablesFromServer(
          this.getSelectedItem.id,
          this.currentEventStart ,
          this.currentLayout.id,
          this.ticketTimes[0].start,
          this.countTotalAmountOfPersons()
      );
    },
    setMapView(){
      this.$nextTick(() => {
        // console.log('changed REFS: ', this.$refs.map);

        //this.$refs.map.mapObject.setView([this.currentLayout.height/2 +80, this.currentLayout.width/2], -0.73);
        // Dirty fix to make fullscreen
        this.$refs.map.mapObject.fitBounds([[0, 0], [this.currentLayout.height, this.currentLayout.width]]);
      });
    },
    changeTimeslot(timeSlot /* , index */){
      // rebuild the timeslot with currently selected Date, it could have changed....

      //console.log('selected Timeslot: ',this.selectedDate, timeSlot );
     // console.log('TT: ',this.ticketTimes);


      // change css Class for this timeSlot to selected, and any other to notselected
      this.ticketTimes.forEach(t => {
        t.cssClass = "timeSlot text-center";
      });

      timeSlot.cssClass="timeSlotSelected text-white bg-dark text-center"; // no Cursor: Pointer etc.



      this.currentTimeSlot = timeSlot;

     // console.log('-> ', this.currentEventStart,'P:', this.getSelectedItem.amountOfPersons);
      //console.log('active Timeslot', this.currentTimeSlot);

      this.loadTicketTablesFromServer(
        this.getSelectedItem.id,
        this.currentEventStart,
        this.currentLayout.id,
        this.currentTimeSlot.start,
        this.countTotalAmountOfPersons()
      );

    },
    changeSelectedTable(table){
      // is this table available?
      if(table.state == 'Available'){
        //console.log('Table Clicked: ', table);

        // update Parent to show the Button after Table is selected
        this.emitSetTableSelection(true);

        // send selected Table to server, that will return all table required for this amountOfPersons (more than 1 Tables sometimes)
       // console.log('ChangeSelectedTable',this.currentEventStart,this.currentTimeSlot.start );

        this.loadTicketSelectTableFromServer(
          this.getSelectedItem.id,
          this.currentEventStart,
          this.currentLayout.id,
          this.currentTimeSlot.start,
          this.countTotalAmountOfPersons(),
          table.id
        );

        //this.currentLayout.selectedTable = table;

      }else{
        //console.log('table not available: ', table);
      }

    },
    emitSetTableSelection: function(e){
      this.$emit('setTableSelected', e);
    },
    amountOFPersonsUpdated: function(){
      //console.log('Persons changed:', this.countTotalAmountOfPersons());

      // can we reload with new Amount or is it not possible yet (not all req. are set yet)
      if(this.currentTimeSlot == undefined){
        //console.log('No Timeslot selected, not updating...');
        return;
      }
      if(this.currentLayout == undefined){
        //console.log('No Layout selected, not updating...');
        return;
      }
      if(this.currentEventStart == undefined){
        //console.log('No EventStart selected, not updating...');
        return;
      }
      //console.log('updating TicketTables now');

      this.loadTicketTablesFromServer(
          this.getSelectedItem.id,
          this.currentEventStart,
          this.currentLayout.id,
          this.currentTimeSlot.start,
          this.countTotalAmountOfPersons()
      );
    },
    countTotalAmountOfPersons() {
      let Amount = 0;
      this.getSelectedItem.personGroups.forEach(element => {
        // ignore NOSEAT
        if (element.seat) {
          Amount += Number.parseFloat(
            element.prices[element.index].numberOfPersons
          );
        }
      });
      return Amount;
    },
    getTableFillStyleForState(style, state){
     //console.log('getTableFillStyleForState: ',style , state);
      try {
          //console.log('->', style[state]);

      // create the style: fill string:
        return "fill: "+style[state] + ";color:"+style[state] + ";list-style-type: square;";
      } catch (error) {
        return "fill: grey; color: grey; list-style-type: square;";
      }
    },
    getTableColors(){
      if(this.currentTableTypes != undefined){
        //console.log('current Table Types:' , this.currentTableTypes);

        let colors = [];
        for(var key in this.currentTableTypes){
          colors.push(this.currentTableTypes[key]);
        }
        return colors;
      }else{
        //console.log('Colors: TableTypes empty ');
        return [];
      }
    },
    getSelectedDateFromRoute: function () {
      if (this.$route.params.date) {
        try {
          let D = moment(this.$route.params.date);
          // console.log('Date ok:', D.toISOString());
          return D;
        } catch (error) {
          console.log('Parsing Date failed:', error);
        }
      }else{
        //console.log('no date in route');
      }

      return undefined;
    },
    getSelectedDateFromShiftTicket(){
      if(this.$store.getters.getChachedCustomerShiftTicket != undefined){
        //console.log('isShift');
        try {
          let D = this.$store.getters.getChachedCustomerShiftTicket.reservationDateTime; // is a string
         // console.log('Date ok:', D);
          return D;
        } catch (error) {
          console.log('Parsing Date failed:', error);
        }
      }
      return undefined;
    },
    getTableSize(typeId){
      //use scale to make proper size
     // console.log('Sclae: ',this.currentScale);

      return [ this.currentTableTypes[typeId].height * this.currentScale,this.currentTableTypes[typeId].width * this.currentScale];
    },
    getTableAnchor(typeId){

      return [ this.currentTableTypes[typeId].height * this.currentScale/2,this.currentTableTypes[typeId].width * this.currentScale/2];
    },


  },
  computed: {
    getIsTableSelected() {return this.isTableSelected;},
    getSelectedLanguage() { return this.$store.getters.getLanguage; },
    getLanguageItem: function() { return this.$store.getters.getLanguageStrings; },
    getServices() {
     // console.log(this.getSelectedItem.type);
      return this.getSelectedItem.fixedPrice;
    },
    getSelectedItem() {
      return this.getCachedItem();
    },
    setSelectPersonsTitle: function(){ //expired
      if(this.getSelectedItem.amountOfPersons != undefined && this.getSelectedItem.amountOfPersons > 0){

        if(this.getSelectedItem.amountOfPersons==1){
          return '' + this.getSelectedItem.amountOfPersons + ' Person   ';
        }else{
          return '' + this.getSelectedItem.amountOfPersons + ' Personen';
        }

      }else{
        return 'Personen wählen';
      }
    },
    setSelectTimeSlotTitle: function(){
      if (this.currentTimeSlot != undefined) {
        //console.log('Timeslot: ', this.currentTimeSlot );

        return  this.currentTimeSlot.start.slice(11, 16);
      }else{
        return 'Uhrzeit auswählen';

      }
    },
    getPersons: function(){ // expired

      let persons = [];
      for (let index = 1; index < this.getSelectedItem.maximumPersons; index++) {
        if(index == 1){
          persons.push(index + ' Person');
        }else{
          persons.push(index + ' Personen');
        }
      }
      return persons;
    },

  },
  beforeMount(){
    moment.locale('de'); // FIXME
    this.getSelectedItem.count = 1;

    // set Default Dates
    this.currentFrom = moment().startOf('month').toISOString().slice(0, 10); //format as YYYY-MM-DD
    this.currentTo = moment().startOf('month').add(12, 'months').toISOString().slice(0, 10); // new Date(new Date().setDate(new Date().getDate() + 31 )).toISOString().slice(0, 10);

    // Load ticketDates from Server
    this.loadTicketDatesFromServer(this.getSelectedItem.id);

  },
  mounted() {
    //this.getSelectedItem.amountOfPersons = 1;
    this.$on('amountOFPersonsUpdated', e => {
      this.amountOFPersonsUpdated(e);
    });
  }
};
</script>

<style scoped>
.datePicker{
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>
